"use strict";
/*
 * Created on Wed Feb 06 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("../../core/model/AdtFlag");
/**
 * Product flag is related to {@link Promotion} validation
 *
 * @author JMt
 */
// tslint:disable:max-classes-per-file


var PromotionWarningFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(PromotionWarningFlag, _AdtFlag_1$AdtFlag);

  function PromotionWarningFlag() {
    _classCallCheck(this, PromotionWarningFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionWarningFlag).apply(this, arguments));
  }

  _createClass(PromotionWarningFlag, [{
    key: "validate",

    /**
     * @inheritDoc
     */
    value: function validate() {
      return true;
    }
  }], [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(PromotionWarningFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(PromotionWarningFlag, data);
    }
  }]);

  return PromotionWarningFlag;
}(AdtFlag_1.AdtFlag);

exports.PromotionWarningFlag = PromotionWarningFlag;
PromotionWarningFlag.TAG = '__PromotionFlag__';
/**
 * @see https://docs.google.com/spreadsheets/d/1RNMrxVqacxTbjkQqE5Ob-Nlh_obIxe0o45C_ydWcxCg/edit#gid=0]
 */

var NotAllSitesAvailableFlag =
/*#__PURE__*/
function (_PromotionWarningFlag) {
  _inherits(NotAllSitesAvailableFlag, _PromotionWarningFlag);

  function NotAllSitesAvailableFlag() {
    _classCallCheck(this, NotAllSitesAvailableFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotAllSitesAvailableFlag).apply(this, arguments));
  }

  return NotAllSitesAvailableFlag;
}(PromotionWarningFlag);

exports.NotAllSitesAvailableFlag = NotAllSitesAvailableFlag;
NotAllSitesAvailableFlag.TAG = PromotionWarningFlag.register(NotAllSitesAvailableFlag);

var EcommercePromotionInvalidStoreSpecificationFlag =
/*#__PURE__*/
function (_PromotionWarningFlag2) {
  _inherits(EcommercePromotionInvalidStoreSpecificationFlag, _PromotionWarningFlag2);

  function EcommercePromotionInvalidStoreSpecificationFlag() {
    _classCallCheck(this, EcommercePromotionInvalidStoreSpecificationFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(EcommercePromotionInvalidStoreSpecificationFlag).apply(this, arguments));
  }

  return EcommercePromotionInvalidStoreSpecificationFlag;
}(PromotionWarningFlag);

exports.EcommercePromotionInvalidStoreSpecificationFlag = EcommercePromotionInvalidStoreSpecificationFlag;
EcommercePromotionInvalidStoreSpecificationFlag.TAG = PromotionWarningFlag.register(EcommercePromotionInvalidStoreSpecificationFlag);

var PromotionManualSplitsInvalidFlag =
/*#__PURE__*/
function (_PromotionWarningFlag3) {
  _inherits(PromotionManualSplitsInvalidFlag, _PromotionWarningFlag3);

  function PromotionManualSplitsInvalidFlag() {
    _classCallCheck(this, PromotionManualSplitsInvalidFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionManualSplitsInvalidFlag).apply(this, arguments));
  }

  return PromotionManualSplitsInvalidFlag;
}(PromotionWarningFlag);

exports.PromotionManualSplitsInvalidFlag = PromotionManualSplitsInvalidFlag;
PromotionManualSplitsInvalidFlag.TAG = PromotionWarningFlag.register(PromotionManualSplitsInvalidFlag);